export default __webpack_public_path__ + "static/media/python.026907cb.svg";